const cardImage = {
  "Doug Jones": require('../Utils/Assets/Images/senators/dJones.jpeg'),
  "Tina Smith": require('../Utils/Assets/Images/senators/tSmith.jpeg'),
  "Lamar Alexander": require('../Utils/Assets/Images/senators/lAlexander.jpeg'),
  "Patty Murray": require('../Utils/Assets/Images/senators/pMurray.jpeg'),
  "Bernard Sanders": require('../Utils/Assets/Images/senators/bSanders.jpeg'),
  "Michael B. Enzi": require('../Utils/Assets/Images/senators/mEnzi.jpeg'),
  "Richard M. Burr": require('../Utils/Assets/Images/senators/rBurr.jpeg'),
  "Bob Casey": require('../Utils/Assets/Images/senators/rCasey.jpeg'),
  "Johnny Isakson": require('../Utils/Assets/Images/senators/jIsakson.jpeg'),
  "Michael Bennet": require('../Utils/Assets/Images/senators/mBennet.jpeg'),
  "Rand Paul": require('../Utils/Assets/Images/senators/rPaul.jpeg'),
  "Sheldon Whitehouse": require('../Utils/Assets/Images/senators/sWhitehouse.jpeg'),
  "Susan Collins": require('../Utils/Assets/Images/senators/sCollins.jpeg'),
  "Tammy Baldwin": require('../Utils/Assets/Images/senators/tBaldwin.jpeg'),
  "Bill Cassidy": require('../Utils/Assets/Images/senators/bCassidy.jpeg'),
  "Todd Young": require('../Utils/Assets/Images/senators/tYoung.jpeg'),
  "Christopher S. Murphy": require('../Utils/Assets/Images/senators/cMurphy.jpeg'),
  "Elizabeth Warren": require('../Utils/Assets/Images/senators/eWarren.jpeg'),
  "Orrin G. Hatch": require('../Utils/Assets/Images/senators/oHatch.jpeg'),
  "Tim Kaine": require('../Utils/Assets/Images/senators/tKaine.jpeg'),
  "Pat Roberts": require('../Utils/Assets/Images/senators/pRoberts.jpeg'),
  "Margaret Hassan": require('../Utils/Assets/Images/senators/mHassan.jpeg'),
  "Lisa Murkowski": require('../Utils/Assets/Images/senators/lMurkowski.jpeg'),
  "Tim Scott": require('../Utils/Assets/Images/senators/tScott.jpeg'),
  "Robert C. Scott": require('../Utils/Assets/Images/representatives/rScott.jpeg'),
  "Virginia Foxx": require('../Utils/Assets/Images/representatives/vFoxx.jpeg'),
  "Joe Wilson": require('../Utils/Assets/Images/representatives/jWilson.jpeg'),
  "Susan A. Davis": require('../Utils/Assets/Images/representatives/sDavis.jpeg'),
  "Raúl M. Grijalva": require('../Utils/Assets/Images/representatives/rGrijalva.jpeg'),
  "Duncan D. Hunter": require('../Utils/Assets/Images/representatives/dHunter.jpeg'),
  "Phil Roe": require('../Utils/Assets/Images/representatives/dRoe.jpeg'),
  "Joe Courtney": require('../Utils/Assets/Images/representatives/jCourtney.jpeg'),
  "Marcia L. Fudge": require('../Utils/Assets/Images/representatives/mFudge.jpeg'),
  "Glenn Thompson": require('../Utils/Assets/Images/representatives/gThompson.jpeg'),
  "Tim Walberg": require('../Utils/Assets/Images/representatives/tWalberg.jpeg'),
  "Jared Polis": require('../Utils/Assets/Images/representatives/jPolis.jpeg'),
  "Brett Guthrie": require('../Utils/Assets/Images/representatives/bGuthrie.jpeg'),
  "Gregorio Kilili Camacho Sablan": require('../Utils/Assets/Images/representatives/gSablan.jpeg'),
  "Todd Rokita": require('../Utils/Assets/Images/representatives/tRokita.jpeg'),
  "Frederica Wilson": require('../Utils/Assets/Images/representatives/fWilson.jpeg'),
  "Suzanne Bonamici": require('../Utils/Assets/Images/representatives/sBonamici.jpeg'),
  "Lou Barletta": require('../Utils/Assets/Images/representatives/lBarletta.jpeg'),
  "Luke Messer": require('../Utils/Assets/Images/representatives/lMesser.jpeg'),
  "Mark Takano": require('../Utils/Assets/Images/representatives/mTakano.jpeg'),
  "Bradley Byrne": require('../Utils/Assets/Images/representatives/bByrne.jpeg'),
  "Alma Adams": require('../Utils/Assets/Images/representatives/aAdams.jpeg'),
  "David A. Brat": require('../Utils/Assets/Images/representatives/dBrat.jpeg'),
  "Mark DeSaulnier": require('../Utils/Assets/Images/representatives/mDeSaulnier.jpeg'),
  "Glenn Grothman": require('../Utils/Assets/Images/representatives/gGrothman.jpeg'),
  "Donald W. Norcross": require('../Utils/Assets/Images/representatives/dNorcross.jpeg'),
  "Elise Stefanik": require('../Utils/Assets/Images/representatives/eStefanik.jpeg'),
  "Lisa Blunt Rochester": require('../Utils/Assets/Images/representatives/lbRochester.jpeg'),
  "Rick Allen": require('../Utils/Assets/Images/representatives/rAllen.jpeg'),
  "Raja Krishnamoorthi": require('../Utils/Assets/Images/representatives/rKrishnamoorthi.jpeg'),
  "Jason Lewis": require('../Utils/Assets/Images/representatives/jLewis.jpeg'),
  "Carol Shea-Porter": require('../Utils/Assets/Images/representatives/cSPorter.jpeg'),
  "Adriano Espaillat": require('../Utils/Assets/Images/representatives/aEspaillat.jpeg'),
  "Francis Rooney": require('../Utils/Assets/Images/representatives/fRooney.jpeg'),
  "Thomas Garrett": require('../Utils/Assets/Images/representatives/tGarrett.jpeg'),
  "Lloyd Smucker": require('../Utils/Assets/Images/representatives/lSmucker.jpeg'),
  "A. Drew Ferguson": require('../Utils/Assets/Images/representatives/dFerguson.jpeg'),
  "Ron Estes": require('../Utils/Assets/Images/representatives/rEstes.jpeg'),
  "Karen Handel": require('../Utils/Assets/Images/representatives/kHandel.jpeg'),
  "Jim Banks": require('../Utils/Assets/Images/representatives/jBanks.jpeg'),
  "Steve Russell": require('../Utils/Assets/Images/representatives/sRussell.jpg'),
  "Mike Bishop": require('../Utils/Assets/Images/representatives/mBishop.jpeg'),
}

export default cardImage